const ru = {
  title: 'Наши работы',
  portfolioButton: 'Подробнее',
};

export default {
  ru,
};
